import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

function collapse(el) {
  if (!el) return;
  el.hidden = true;
  el.style.display = 'none';
}

function reveal(el) {
  if (!el) return;
  el.hidden = false;
  el.style.display = '';
}

async function hydrateRecentlyViewed() {
  const root = document.querySelector('[data-bc-recently-viewed]');
  if (!root || root.dataset.bcRvHydrated === '1') return;

  const sectionId = root.dataset.sectionId;
  const currentId = root.dataset.currentProductId;
  const max = parseInt(root.dataset.maxItems || '6', 10);
  const themeRoutes = (typeof Theme !== 'undefined' && Theme?.routes) || window.Theme?.routes;
  const searchUrl = themeRoutes?.search_url;

  if (!sectionId || !searchUrl) {
    collapse(root);
    return;
  }

  const ids = RecentlyViewed.getProducts()
    .filter((id) => String(id) !== String(currentId))
    .slice(0, max);

  if (ids.length === 0) {
    collapse(root);
    return;
  }

  root.dataset.bcRvHydrated = '1';

  const url = new URL(searchUrl, location.origin);
  url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
  url.searchParams.set('type', 'product');

  try {
    await sectionRenderer.renderSection(sectionId, { cache: false, url });
    const updated = document.querySelector(
      `[data-bc-recently-viewed][data-section-id="${sectionId}"]`
    );
    const hasCards = updated?.querySelector('[data-bc-rv-card]');
    if (hasCards) {
      reveal(updated);
    } else {
      collapse(updated || root);
    }
  } catch (err) {
    console.warn('[brightcode-recently-viewed]', err);
    collapse(root);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hydrateRecentlyViewed);
} else {
  hydrateRecentlyViewed();
}
